<template>
  <div id="app" class="main__container">
    <div class="content noselect">
      <img
        class="navigation__logo"
        src="./assets/logo/logoweb.png">
      <div class="text">
        <h1>UNDER CONSTRUCTION!</h1>
        <p>Until October you can insult your brain over here:</p>
      </div>
      <div class="links">
        <a href="https://www.instagram.com/buffalo_bill_gates/" target="_blank">INSTAGRAM</a>
        <a href="https://studio-kalle-mattsson.myshopify.com/" target="_blank">SHOP</a>
      </div>
    </div>
    <div class="rectangle__1" :style="{ transform: 'rotate(' + Math.floor(Math.random() * 360) + 'deg)' }"/>
    <div class="rectangle__2" :style="{ transform: 'rotate(' + Math.floor(Math.random() * 360) + 'deg)' }"/>
    <div class="rectangle__3" :style="{ transform: 'rotate(' + Math.floor(Math.random() * 360) + 'deg)' }"/>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store()

export default {
  metaInfo: {
    title: 'Buffalo Bill Gates - Under Construction',
    meta: [
      { name: 'author', content: 'Christian Augustin' },
      { name: 'viewport', content: 'width=device-width,initial-scale=1.0' },
      { charset: 'utf-8'}
    ]
  },
  components: {
  },
  computed: {
    foo () {
      return this.$store.state.foo
    },
  }
}
</script>

<style lang="postcss">

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  color: #000;
  display: grid;
  grid-template-columns: 10vw auto 10vw;
  grid-template-rows: 1fr auto 1fr;
  grid-gap: 0px;
  margin: 0px;
  padding: 0px;
  width: 100vw;
  height: 100vh; 
}

.content {
  grid-column: 2 / 2;
  grid-row: 2 / 2;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr 1fr;
  grid-gap: 0px;
  /* background-color: rgba(0, 0, 0, 0.3); */
  padding: 0px;
  }

.navigation__logo {
  z-index: 10;
  grid-column: 1 / -1;
  grid-row: 1 / 1;
  display: grid;
  height: 30vh;
  width: 30vh;
  /* background-color: rgba(0, 0, 0, 0.3); */
  justify-self: center;
  align-self: center;
}

.text {
  z-index: 10;
  display: grid;
  justify-self: center;
  align-self: center;
  margin-top: 2vh;
  width: 100%;
  font-size: 2vw;
}

.links {
  z-index: 10;
  display: grid;
  justify-self: center;
  align-self: center;
  /* background-color: rgba(0, 0, 0, 0.3); */
  grid-gap: 0.5vh;
  font-size: 3vw;
}

@media (orientation: portrait) {

  .content {
    margin-top: -4vh;
  }

  .text {
    font-size: 3vw;
  }

  .links {
    font-size: 6vw;
  }

  p {
    margin: 20px;
    font-size: 5vw;
  }

}

.rectangle__1 {
  -webkit-box-shadow: 0 0 5vh 5vh rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 5vh 5vh rgba(0, 0, 0, 0.1);
  transform-origin: center center;
  transform: rotate(20deg);
  left: -20vw;
  top: -50vh;
  position: fixed;
  height: 50vw;
  width: 50vw;
}

.rectangle__2 {
  -webkit-box-shadow: 0 0 5vh 5vh rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 5vh 5vh rgba(0, 0, 0, 0.1);
  transform-origin: center center;
  transform: rotate(20deg);
  right: -20vw;
  top: -30vh;
  position: fixed;
  height: 50vw;
  width: 50vw;
}

.rectangle__3 {
  -webkit-box-shadow: 0 0 5vh 5vh rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 5vh 5vh rgba(0, 0, 0, 0.1);
  transform-origin: center center;
  transform: rotate(20deg);
  left: 25vw;
  bottom: -150vh;
  position: fixed;
  height: 75vw;
  width: 75vw;
}

@media (orientation: portrait) {
  .rectangle__1 {
    top: -25vh;
    width: 50vh;
    height: 59vh;
  }

  .rectangle__2 {
    top: 75vh;
    width: 50vh;
    height: 59vh;
  }

}

html, body { 
  margin:0;
  padding:0;
  width:100%;
  height:100%;
  overflow: auto;
}

h1, h2, h3 {
  font-family: 'druk-medium';
  margin: 2vh;
}

p {
  margin-top: -2vh;
  font-family: 'cooper';
}

@font-face {
  font-family: "druk-bold";
  src: url("assets/fonts/DrukWide-bold.otf") format("opentype");
  /* src: url("assets/fonts/Roboto-Light.woff2") format("woff2"); */
}

@font-face {
  font-family: "druk-medium";
  src: url("assets/fonts/DrukWide-medium.otf") format("opentype");
}

@font-face {
  font-family: "buffalo";
  src: url("assets/fonts/FranklinBuffalo-condensed.ttf") format("truetype");
}

@font-face {
  font-family: "cooper";
  src: url("assets/fonts/Cooper-regular.otf") format("opentype");
}

/* @media (max-width: 450px) {
  .main__container {
    grid-template-rows: 12vw repeat(auto-fit, minmax(5vh, 1fr));
  }
} */

body {
  color: #1D212F;
  background-color: #BCB3A9
}

a {
  font-family: 'druk-medium';
  font-weight: 300;
  color: #fff;
  text-decoration: none;
}

a:hover { 
  color: #000;
}

li {
  list-style-type: none;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}

</style>
